<template>
  <BootstrapModal class="EditWebsiteMenu"
    v-on="$listeners"

    @save="saveProductGroup"
  >
    <FormInput
      class="form-element"
      v-model="$v.name.$model"

      id="brand"
      label="Merk"

      :vuelidate="$v"
      fieldName="name"
    />

    <template #title>
      {{ brand ? "Merk bewerken" : "Merk toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["brand", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      name: "",
    }
  },
  created() {
    if (this.brand) {
      this.$v.name.$model = this.brand.name
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
      }

      this.$handlePromise(async () => {
        if (this.brand) {
          await this.axios.put(`/api/brands/${this.brand.uid}`, payload)
        } else {
          await this.axios.post(`/api/brands`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "brands")

        this.$success("Merk succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditWebsiteMenu {
  flex-basis: 500px;
}

</style>
